import React from "react";
import ReactDOM from "react-dom";
// import { ErrorBoundary } from "react-error-boundary";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";
import AppRouter from "./routes";
import HttpServices from "./environments/environment_urls";

window.$ = window.jQuery = require("jquery");
window.addEventListener("error", (e) => {
  const message = e.error?.message || e.message || "";
  if (message.includes("Loading chunk")) {
    window.location.reload();
  }
});
HttpServices.setupFetchInterceptor();

ReactDOM.render(
  // <ErrorBoundary FallbackComponent={ErrorFallback}>
  <AppRouter />,
  // </ErrorBoundary>,
  document.getElementById("prokraya-app")
);
